import { useState, useCallback } from 'react';
import { EnhancedStockData } from '@/types/deals';
import { getDeals } from '@/lib/api/dealsApi';

export function useDeals() {
  const [stocks, setStocks] = useState<EnhancedStockData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDeals = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getDeals(filters);
      setStocks(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load deals data. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    stocks,
    loading,
    error,
    fetchDeals,
  };
} 